import styled, { css } from "styled-components";

export const WrapperBtn = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  width: 100%;

  ${({ $isRounded }) => $isRounded && css`
    border-radius: 8px;
  `}
`

export const Slide = styled.div`
  position: relative;

  img {
    width: 100%;
    object-fit: cover;
    object-position: top center;
    transition: transform 400ms;
    aspect-ratio: 16 / 9;

    ${({ $isRounded }) => $isRounded && css`
      border-radius: 8px;
    `}
  }

  ${({ $isHoverEffect }) => $isHoverEffect && css`
    :hover {
      img {
        transform: scale(.9)
      }
    }
  `}
`
